import Dialog from "../../components/Dialog";
import { useState } from "react";
import WordTranslationForm from "./WordTranslationForm";

export default function WordTranslationDialog({ visible, hide, item, preloaded, ...props }) {
	const [loading, setLoading] = useState(false);

	return (
		<Dialog
			title={item ? "Update Word Translation" : "Add Word Translation"}
			visible={visible} onCancel={hide} closable={!loading}
		>
			<WordTranslationForm
				{...props} id={item?.id}
				item={preloaded ? item : undefined}
				submitting={loading}
				setSubmitting={l => setLoading(l)}
				onCancel={hide}
			/>
		</Dialog>
	)
}
